import { ShoppingCart } from "@mui/icons-material";
import { IFeatures } from "../../utils/interfaces";
import { useSessionContext } from "../../contexts/SessionContext";
import { useOrganizationContext } from "@/contexts/OrganizationContext";
import EcommercePage from "./EcommercePage";
import { isEcommerceOrganization } from "./helpers/isEcommerceOrganization";

/**
 * Feature Ecommerce: visível só para profissional com a organização
 * atualmente selecionada do tipo ecommerce.
 */
export function useEcommerce() {
  const { access } = useSessionContext();
  const { organization } = useOrganizationContext();

  const isEcommerceOrg = isEcommerceOrganization(organization);

  const configs: IFeatures = {
    active:
      access.type === "professional" && isEcommerceOrg,
    initial: isEcommerceOrg,
    path: "/ecommerce",
    icon: ShoppingCart,
    text: "Ecommerce",
    sideMenu: true,
    sideMenuIndex: 0,
    component: () => <EcommercePage />,
  };

  return configs;
}
